<template>
  <div class="device-detail-event-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent label-position="left">
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right">
          <el-button class="table-set"   style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 日期过滤 -->
        <el-form-item style="float: right">
          <!-- 部件编码  -->
          <search-input v-model="formSearch.search" :placeholder="$t('dms_device_detail_log.ying_yong_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_device_detail_log.jie_shu_shi_jian')" style="width: 35% !important">
          <custom-date-picker style="width: 100%" v-model="formSearch.pubTimer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionsIntervalMonth"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_device_detail_log.shang_chuan_shi_jian')" style="width: 35% !important">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.uploadTimer"
            type="datetimerange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
      :data="tableList" :column="tableColumn"
      :slots="['action']"
      @filter="filterChange" @sort="sortChange" max-height="600"
    >
        <template v-slot:action="scope">
          <el-button type="text" size="mini"  v-if="scope.row.attachId" @click="onDownload(scope.row)">{{ $t('dms_device_detail_log.xia_zai') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  mixins: [resetFormSearchMixins],
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },

    isModem: { type: Boolean, default: false },
  },
  components: { },
  data() {
    return {
      tableCode: 'device_detail_log',
      provide: true,
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        bodyNum: '',
        search: '',
        pubTimer: [],
        pubStartDate: '',
        pubEndDate: '',
        uploadTimer: [],
        uploadStartDate: '',
        uploadEndDate: ''
      },
      // 日期选择范围在一个月内
      // pickerOptionsIntervalMonth: {
      //   onPick: ({ maxDate, minDate }) => {
      //     this.selectDate = minDate.getTime();
      //     if (maxDate) {
      //       this.selectDate = '';
      //     }
      //   },
      //   // eslint-disable-next-line consistent-return
      //   disabledDate: (time) => {
      //     if (this.selectDate) {
      //       const limitRange = 31 * 24 * 3600 * 1000; // 31天范围内可选
      //       const maxTime = this.selectDate + limitRange;
      //       const minTime = this.selectDate - limitRange;
      //       return (
      //         time.getTime() > maxTime
      //         || time.getTime() < minTime
      //         || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000
      //       );
      //     } else {
      //       return time.getTime() > Date.now() + 0 * 24 * 3600 * 1000;
      //     }
      //   },
      // },
      exportTimer: '',
      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.formSearch.bodyNum = this.deviceInfo.bodyNum;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      // this.formSearch.endDate = moment(this.formSearch.startDate).format('YYYY-MM-DD 23:59:59');
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.formSearch.pubStartDate = this.formSearch.pubTimer && this.formSearch.pubTimer[0] ? this.formSearch.pubTimer[0] : undefined;
      this.formSearch.pubEndDate = this.formSearch.pubTimer && this.formSearch.pubTimer[1] ? this.formSearch.pubTimer[1] : undefined;
      this.formSearch.uploadStartDate = this.formSearch.uploadTimer && this.formSearch.uploadTimer[0] ? this.formSearch.uploadTimer[0] : undefined;
      this.formSearch.uploadEndDate = this.formSearch.uploadTimer && this.formSearch.uploadTimer[1] ? this.formSearch.uploadTimer[1] : undefined;
      this.$getJSON(apis.DeviceResumeLogPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.DeviceResumeLogExport, this.formSearch).then(() => { });
    },
    // 数据导出
    onDownload: function (row) {
      const attachId = row.attachId;
      if (!attachId) {
        return;
      }
      this.$getAttachFile(attachId).then((res) => {
        const item = res;
        if (item) {
          this.jumpOutside(this.getAttachUrl(item), true);
        }
        //  else {
        //   this.$message({
        //     message: '合同附件缺失',
        //     type: 'error'
        //   });
        // }
      });
    },
  },
};
</script>

<style lang="scss">
.device-detail-event-bd {
  padding: 8px 24px 44px 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
</style>
